/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import { Link } from './styles'

export default function NavLink(props) {
  return (
    <Link {...props} />
  )
}
